import React, {useState} from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { amber, green } from '@material-ui/core/colors';

import {devConsolelog} from '../../Utility';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

function MySnackbarContentWrapper({variant = null, message = ""}) {
  const classes = useStyles();
  // const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];
  if(!Boolean(message)) return null;
  return (
    <SnackbarContent
      className={classes[variant]}
      message={<span id="client-snackbar" className={classes.message}>
        <Icon className={`${classes.icon}, ${classes.iconVariant}`} />
        {message}
      </span>}
    />
  );
}

function MySnackbar(props) {
  devConsolelog('MySnackbar render ', props);
  return (<Snackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    open={Boolean(props.message)}
    onClose={() => props.setViewSnackbar({message: null, type: null})}
    autoHideDuration={3000}
    ContentProps={{
      'aria-describedby': 'message-id',
    }}
  >
    <MySnackbarContentWrapper {...props} />
  </Snackbar>)
}

export default MySnackbar
